import React from 'react';
import config from 'react-global-configuration';

import { MAATJES_DOMAIN, KP_DOMAIN, NLDOET_DOMAIN, APPELTJES_DOMAIN } from '../../config/constants';

import NavigationFull from './Full';
import NavigationCampaign from './Campaign';
import NavigationPrivacy from './Privacy';
import NavigationKP from './KP';
import GenericNavigation from './Generic';

const Navigation = ({ variant, campaignEntity, entityType }) => {
  const currentDomain = config.get('CURRENT_DOMAIN');

  // Domain‑specific navigation
  const domainMap = {
    [NLDOET_DOMAIN]: <GenericNavigation entityType={entityType} />,
    [APPELTJES_DOMAIN]: <GenericNavigation entityType={entityType} />,
    [MAATJES_DOMAIN]: <GenericNavigation entityType={entityType} />,
    [KP_DOMAIN]: <NavigationKP />,
  };
  if (domainMap[currentDomain]) return domainMap[currentDomain];

  // Variant‑specific navigation
  const variantMap = {
    campaign: <NavigationCampaign campaignEntity={campaignEntity} />,
    privacy: <NavigationPrivacy />,
  };
  return variantMap[variant] ?? <NavigationFull />; // Default fallback

};

export default Navigation;
